<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
    <div
        class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
        <form [formGroup]="configForm" (ngSubmit)="onSave()">
            <h1 class="heading">
                {{configId ? 'Edit' : 'Add'}}
                 <!-- Add -->
            </h1>
            <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

            <section class="grid gap-4 md:grid-cols-2">

                <!-- title -->
                <div class="space-y-1">
                    <label class="subheading">
                        Reference <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input type="text" formControlName="reference" />
                        </div>
                    </div>
                    <div *ngIf="form.reference.errors && submitted">
                        <div *ngIf="form.reference.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                Reference is required
                            </p>
                        </div>
                    </div>
                </div>

                
                  <div class="space-y-1">
                    <label class="subheading">
                        Base Url <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input type="text" formControlName="generalUrl" />
                        </div>
                    </div>
                    <div *ngIf="form.generalUrl.errors && submitted">
                        <div *ngIf="form.generalUrl.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                General Url is required
                            </p>
                        </div>
                    </div>
                </div>

                <div class="space-y-1">
                    <label class="subheading">
                        Trip Url <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input type="text" formControlName="tripUrl" />
                        </div>
                    </div>
                    <div *ngIf="form.tripUrl.errors && submitted">
                        <div *ngIf="form.tripUrl.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                Trip Url is required
                            </p>
                        </div>
                    </div>
                </div>

                  <div class="space-y-1">
                    <label class="subheading">
                        Vehicle Url
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input type="text" formControlName="vehicleUrl" />
                        </div>
                    </div>
                </div>

                  <div class="space-y-1">
                    <label class="subheading">
                        Driver Url
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input type="text" formControlName="driverUrl" />
                        </div>
                    </div>
                </div>

                <!-- <div class="space-y-1 col-span-full">
                    <h1 class="heading pb-2">
                       Quickbook
                    </h1>
                    <hr class="my-6 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                </div> -->



                <!-- <ng-container formGroupName="quickbooks">
                    <div class="space-y-1">
                        <label class="subheading">
                             Email
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <input type="text" formControlName="username" />
                            </div>
                        </div>
                    </div>
                
                    <div class="space-y-1">
                        <label class="subheading">
                             Password
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <input type="text" formControlName="password" />
                            </div>
                        </div>
                    </div>

                        <div class="space-y-1">
                        <label class="subheading">
                             URL
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <input type="text" formControlName="url" />
                            </div>
                        </div>
                    </div>

                </ng-container> -->
                 



                 <div class="space-y-1">
                    <label class="subheading">
                        Status
                    </label>
                    <div>
                        <div>
                            <select formControlName="isActive">
                                <option [ngValue]="true">Active</option>
                                <option [ngValue]="false">Inactive</option>
                            </select>
                        </div>
                        
                    </div>
                </div>
                <div class="space-y-1 col-span-full">
                    <div class="border border-gray-300 rounded-lg p-4">
                        <fieldset>
                            <div class="flex items-center flex-wrap gap-3 mt-2">
                
                                <div class="relative flex items-center border border-dashed px-2 py-1 rounded">
                                    <div class="flex h-6 items-center">
                                        <input id="isAllowEmail" formControlName="isAllowEmail" aria-describedby="isAllowEmail"
                                            name="isAllowEmail" type="checkbox"
                                            class="h-4 w-4 text-main-secondary border-gray-300 rounded focus:ring-main-secondary">
                                    </div>
                                    <div class="ml-2 text-sm leading-6">
                                        <label for="isAllowEmail" class="cursor-pointer text-sm font-medium text-main-secondary">
                                            Allow Email
                                        </label>
                                    </div>
                                </div>
                
                                <!-- Add more permission items here in same style -->
                
                            </div>
                        </fieldset>
                    </div>
                </div>


               
            </section>
            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="flex justify-end gap-4">
                <button type="submit" class="btn btn-secondary">
                    {{configId ? 'Update' : 'Create'}}
                     <!-- Save -->
                </button>
            </section>
        </form>
    </div>
</section>